/* eslint react/jsx-no-bind:0 */
import React from "react";
import { Switch, Route, Redirect,withRouter } from "react-router-dom"
import { processSilentRenew } from 'redux-oidc'
import Register from "./containers/UserRegistration"
import IndexPage from "./components/layout/IndexPage"
//import NotAvailable from "./containers/NotAvailable"
import CallbackComponent from './CallbackComponent.js'
import "./Vendor.js"
import "./styles/bootstrap.scss"
import "./styles/app.scss"

const App = () => (
  <Switch>
    <Route path="/signin-oidc" component={CallbackComponent} />
    <Route path="/signin-silentrenew" component={()=><div>{processSilentRenew()}</div>} />
    <Route path="/signout-callback-oidc" component={()=><Redirect to="/"/>} />
    <Route path="/register" component={Register} />
    <Route path="/" component={IndexPage} /> 
  </Switch>
)
export default withRouter(App)



// WEBPACK FOOTER //
// ./src/App.js